import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'martor',
} as IModuleProps;
